import { Outlet } from "react-router-dom";
import { SideNav } from "./SideNav";
import { TopNav } from "./TopNav";
import { ImpersonatingUser } from "./ImpersonatingUser";

export const PageLayout = () => {
  return (
    <>
      <ImpersonatingUser />
      <div className="flex h-screen items-center pl-8">
        <SideNav />
        <div className="flex h-full flex-1 flex-col overflow-x-hidden px-16 py-6 scrollbar-thin">
          <TopNav />
          <div className="flex flex-1 flex-col">
            <Outlet />
          </div>
        </div>
      </div>
    </>
  );
};
